import { extendTheme } from '@chakra-ui/react';
import baseTheme from '../theme';
export var CONTACT_EMAIL = 'sascha.kallensee@primo-me.com';
export var PRIVACY_POLICY_URL = '/public/legal/privacy-policy.pdf';
// Worker version must match the installed pdfjs-dist (3.11.174).
export var PDF_WORKER_URL = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
// Keep the dark landing-page background behind the app.
export var enTheme = extendTheme({
    styles: {
        global: {
            'html, body': { background: '#0a0a0a', color: 'white' },
        },
    },
}, baseTheme);
